import React, { useState, useEffect } from 'react';
import { Dimmer, Loader, Table } from 'semantic-ui-react';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { StoreState } from '../../types/state';
import { getAllTasks, updateTask } from '../../redux/actions/tasks';
import EditDialog from '../Common/EditDialog';
import Actions from '../Common/Actions';
import Filters from '../Common/Filters';
import taskFormSchema from './taskFormSchema.json';
import { getLocalTime, timestampColumns } from '../../utils';
const TASKCOLUMNS: string[] = [
  'id',
  'Name',
  'Description',
  'Module',
  'DefaultSchedule',
  'DefaultTimeZone',
  'TaskSubmitPath',
  'Enabled',
  'createdAt',
  'updatedAt',
];

const TaskList = (props: TaskListReduxProps) => {
  const { isLoading, tasks, getAllTasks } = props;
  const [editTask, setEditTask] = useState(undefined);

  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const [filteredTasks, setFilteredTasks] = useState([]);

  useEffect(() => {
    getAllTasks();
  }, [getAllTasks]);

  const handleDisable = (id: string) => {
    const [task] = tasks.filter((elem: any) => elem.id);
    if (task) {
      props.updateTask({ ...task, Enabled: !task.Enabled });
    }
  };

  const handleUpdate = (data: any) => {
    props.updateTask({ ...editTask, ...data });
  };

  return (
    <div>
      {editTask ? (
        <EditDialog
          update={handleUpdate}
          formData={editTask}
          onClose={() => setEditTask(undefined)}
          formSchema={taskFormSchema}
        />
      ) : null}
      <h2>Task List</h2>
      {Object.keys(tasks).length > 0 && (
        <Filters
          filteredLists={filteredTasks}
          originalList={Object.values(tasks)}
          allowedParams={['Name', 'Module', 'Description', 'DefaultTimeZone']}
          setFilteredLists={setFilteredTasks}
        />
      )}
      {isLoading ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <Table size="small" selectable>
          <Table.Header>
            <Table.Row>
              {TASKCOLUMNS.concat('Actions').map((elem) => {
                return (
                  <Table.HeaderCell key={elem}>
                    {elem.toString()}
                  </Table.HeaderCell>
                );
              })}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {filteredTasks.map((task: any) => {
              return (
                <Table.Row key={task.id}>
                  {TASKCOLUMNS.map((taskValue: any) => {
                    return (
                      <Table.Cell key={taskValue + task.id}>
                        {timestampColumns.includes(taskValue) && useLocalTime
                          ? getLocalTime(task[taskValue])
                          : task[taskValue] === false
                          ? 'false'
                          : task[taskValue]
                          ? task[taskValue]
                          : ''}
                      </Table.Cell>
                    );
                  }).concat(
                    <Table.Cell key={'action' + task.id}>
                      <Actions
                        showEdit
                        showDetails
                        showEnable
                        isDisabled={!task.Enabled}
                        onDisable={() => {
                          handleDisable(task.id);
                        }}
                        onEdit={() => {
                          setEditTask(task);
                        }}
                        detailsLink={`/tasks/task/${task.id}`}
                      />
                    </Table.Cell>
                  )}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      )}
    </div>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    tasks: state.tasks.tasks,
    isLoading: state.tasks.isLoading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      getAllTasks,
      updateTask,
    },
    dispatch
  );
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type TaskListReduxProps = ConnectedProps<typeof connector>;

export default connector(TaskList);
